import React from 'react';
import { IconButton } from '@material-ui/core';
import './index.scss';
import ArrowRightNewLayout from 'components/Icons/ArrowRightNewLayout';
import ArrowLeftNewLayout from 'components/Icons/ArrowLeftNewLayout';

interface PaginacaoProps {
    paginaAtual: number;
    totalPages: number;
    setPaginaAtual: (pagina: number) => void;
    totalElements: number;
}

const Paginacao: React.FC<PaginacaoProps> = ({ paginaAtual, totalPages, setPaginaAtual, totalElements }) => {

    const itensPorPagina = 10;
    const inicio = (paginaAtual - 1) * itensPorPagina + 1;
    const fim = Math.min(paginaAtual * itensPorPagina, totalElements);

    const gerarPaginas = () => {
        const paginas = [];
        const maxPaginasVisiveis = 4;

        if (totalPages <= maxPaginasVisiveis) {
            for (let i = 1; i <= totalPages; i++) {
                paginas.push(i);
            }
        } else {
            const mostrarInicio = paginaAtual <= 3;
            const mostrarFim = paginaAtual >= totalPages - 2;

            if (mostrarInicio) {
                paginas.push(1, 2, 3, 4, '...', totalPages);
            } else if (mostrarFim) {
                paginas.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                paginas.push(1, '...', paginaAtual - 1, paginaAtual, paginaAtual + 1, '...', totalPages);
            }
        }
        return paginas;
    };

    return (
        <div className="paginacao-container">
            <div className='paginacao-items'>
                <span>
                    {inicio} - {fim} de {totalElements} itens
                </span>
            </div>

            <div className='paginacao-actions'>

                <IconButton
                    onClick={() => setPaginaAtual(Math.max(paginaAtual - 1, 1))}
                    disabled={paginaAtual === 1}
                    className="paginacao-botao"
                >
                    <ArrowLeftNewLayout color={paginaAtual === 1 ? '#ccc' : '#33820D'} />
                </IconButton>

                {gerarPaginas().map((page, index) => {
                    if (page === '...') {
                        return <span key={`ellipsis-${index}`} className="paginacao-ellipsis">...</span>;
                    }
                    return (
                        <button
                            key={page}
                            onClick={() => setPaginaAtual(Number(page))}
                            className={`pagina-botao ${page === paginaAtual ? 'ativa' : ''}`}
                        >
                            {page}
                        </button>
                    );
                })}
                <IconButton
                    onClick={() => setPaginaAtual(paginaAtual < totalPages ? paginaAtual + 1 : paginaAtual)}
                    disabled={paginaAtual === totalPages}
                    className="paginacao-botao"
                >
                    <ArrowRightNewLayout color={paginaAtual === totalPages ? '#ccc' : '#33820D'} />
                </IconButton>
            </div>
        </div>
    );
};


export default Paginacao;
